// extracted by mini-css-extract-plugin
export var author = "BlogCard-module--author--f63dd";
export var card = "BlogCard-module--card--1c668";
export var category = "BlogCard-module--category--e4f56";
export var content = "BlogCard-module--content--2c7ec";
export var ctaContainer = "BlogCard-module--cta-container--2408a";
export var date = "BlogCard-module--date--cadf0";
export var image = "BlogCard-module--image--7c9a3";
export var imageInner = "BlogCard-module--image-inner--b5554";
export var title = "BlogCard-module--title--541e6";